import './consignmentPickUp.css';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
// import { CommonRegistrationSidebar } from "../../common/common-registration-sidebar/commonRegistrationSideba
import Grid from '@mui/material/Grid';
import { authKey, GET_CONSIGNMENT_DETAILS_BY_NUMBER, CONSIGNMENT_SAVE, TRIP_START, CREATE_DELIVERY_CHALLAN, PRINT_DOWNLOAD_DATA, UPDATE_CONSIGNMENT_LOT_DETAILS } from '../../../common/URLs';

import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { confirmAlert } from 'react-confirm-alert';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { useLocation } from "react-router-dom";
import { DialogContent, Dialog, DialogActions, Button } from '@mui/material';
import Moment from 'moment';
import { PROD } from '../../../common/constants';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import apiClient from '../../../axios';

function ConsignmentLotDetails() {


  const { state } = useLocation();


  const navigate = useNavigate();
  const [consignmentdetails, setConsignmentdetails] = useState();
  const [consignmentsource, setConsignmentsource] = useState();
  const [consignmentsave, setConsignmentsave] = useState();
  const [saveConsignmentResponse, setSaveConsignmentResponse] = useState();
  const [starttrip, setStarttrip] = useState();
  const [showStarttrip, setShowStarttrip] = useState(true);
  const [consignemntsaveResponse, setConsignemntsaveResponse] = useState();
  const [consignmentNoDetails, setConsignmentNoDetails] = useState({
    "consignmentNo": state?.consignmentNo ? state?.consignmentNo : "",
    "odometerStart": "",
    // "vehicleBarcode":"",
    "comments": "",
  });
  const [createDeliveryChallan, setCreateDeliveryChallan] = useState();
  const [downloadDeliveryChallan, setDownloadDeliveryChallan] = useState();

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const [logModalOpen3, setLogModalOpen3] = useState(false);
  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalClose1 = () => setLogModalOpen1(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => setLogModalOpen2(false);
  const handleLogModalOpen3 = () => setLogModalOpen3(true);
  const handleLogModalClose3 = () => setLogModalOpen3(false);


  const [errorMessage, setErrorMessage] = useState({
    consignmentNoError: "",
    odometerStartError: "",
    vehicleBarcodeError: "",
  });

  const [urn, setUrn] = useState();
  const [showGrid, setShowGrid] = useState(false);
  const [showRB, setShowRB] = useState(false);
  const [showCB, setShowCB] = useState(false);

  const onAddBundle = (e) => {
    e.preventDefault();
    setShowGrid(true);
  }
  const onRawbamboo = (e) => {
    e.preventDefault();
    setShowRB(true);
  }
  const onChipedBamboo = (e) => {
    e.preventDefault();
    navigate("/ConsignmentCB");
  }
  const viewUpdatePickup = (e, growerItem) => {
    e.preventDefault();
    const userData = {
      consignmentNo: consignmentNoDetails.consignmentNo,
    };
    navigate("/PickUpLotDetails", { state: { consignmentdetails: consignmentdetails, growerItem: growerItem } });
  }
  const gotoHarvestingDetails = (e) => {
    e.preventDefault();
    navigate("/HarvestingDetails");
  }

  const handleChange = (e) => {

    setConsignmentNoDetails({

      ...consignmentNoDetails,

      [e.target.name]: e.target.value,

    });

    if (e.target.name === "consignmentNo") {
      setErrorMessage({ ...errorMessage, consignmentNoError: "" });
    }
    if (e.target.name === "odometerStart") {
      setErrorMessage({ ...errorMessage, odometerStartError: "" });
    }
    // if (e.target.name === "vehicleBarcode") 
    // {
    //   setErrorMessage({ ...errorMessage, vehicleBarcodeError: "" });
    // }
    if (e.target.name === "comments") {
      setErrorMessage({ ...errorMessage, commentsError: "" });
    }
  }


  const getDetails = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      getConsignmentDetails();
    }
  }

  useEffect(() => {
    getConsignmentDetails();
  }, [state?.consignmentNo])

  useEffect(()=>{
     let growerItemUpdated = state?.growerItem;
     console.log("growerItem",state?.growerItem)
    
     getConsignmentDetails();
  },[]);

  // useEffect(() => {
  //   if (saveConsignmentResponse) {
  //     if (saveConsignmentResponse.isSuccess === "true") {
  //       confirmAlert({
  //         customUI: ({ onClose }) => {
  //           return (
  //             <ErrorPopover
  //               title={saveConsignmentResponse.message}
  //               onClose={onClose}
  //               navigate={navigate("/gotoDashboard")} hideLink={true}
  //             ></ErrorPopover>
  //           );
  //         },
  //       });
  //     } else {
  //       confirmAlert({
  //         customUI: ({ onClose }) => {
  //           return (
  //             <ConfirmPopover
  //               onClose={onClose}
  //               title={
  //                 saveConsignmentResponse?.message
  //                   ? saveConsignmentResponse?.message
  //                   : 
  //                 "Error"
  //               } hideLink={true}
  //             />
  //           );
  //         },
  //       });
  //     }
  //   }
  // }, [saveConsignmentResponse]);

  useEffect(() => {
    if (saveConsignmentResponse) {
      if (saveConsignmentResponse.isSuccess === true) {
        // confirmAlert({
        //   customUI: ({ onClose }) => {
        //     return (
        //       <ErrorPopover
        //         title={pickupDetailsSave.message}
        //         onClose={onClose} hideLink={true}
        //       ></ErrorPopover> 
        //     );
        //   },
        // });
        handleLogModalOpen2();
      }
      else {
        // confirmAlert({
        //   customUI: ({ onClose }) => {
        //     return (
        //       <ConfirmPopover
        //         onClose={onClose}
        //         title={
        //           pickupDetailsSave?.message
        //             ? pickupDetailsSave?.message
        //             : 
        //           "Error"
        //         } hideLink={true}
        //       />
        //     );
        //   },
        // });
        handleLogModalOpen();
      }
    }
  }, [saveConsignmentResponse]);
  // useEffect(() => {
  //   if (starttrip) {
  //     if (starttrip.isSuccess === "true") {
  //       confirmAlert({
  //         customUI: ({ onClose }) => {
  //           return (
  //             <ErrorPopover
  //               title={starttrip.message}
  //               onClose={onClose}
  //               navigate={navigate("/gotoDashboard")} hideLink={true}
  //             ></ErrorPopover>
  //           );
  //         },
  //       });
  //     } else {
  //       confirmAlert({
  //         customUI: ({ onClose }) => {
  //           return (
  //             <ConfirmPopover
  //               onClose={onClose}
  //               title={
  //                 starttrip?.message
  //                   ? starttrip?.message
  //                   : 
  //                 "Error"
  //               } hideLink={true}
  //             />
  //           );
  //         },
  //       });
  //     }
  //   }
  // }, [starttrip]);

  //  useEffect(() => { 
  //   getConsignmentDetails();
  //  },[consignmentNoDetails?.consignmentNo]
  //  );

  useEffect(() => {
    if (starttrip) {
      if (starttrip.isSuccess === true) {
        // confirmAlert({
        //   customUI: ({ onClose }) => {
        //     return (
        //       <ErrorPopover
        //         title={pickupDetailsSave.message}
        //         onClose={onClose} hideLink={true}
        //       ></ErrorPopover> 
        //     );
        //   },
        // });
        handleLogModalOpen1();
      }
      else {
        // confirmAlert({
        //   customUI: ({ onClose }) => {
        //     return (
        //       <ConfirmPopover
        //         onClose={onClose}
        //         title={
        //           pickupDetailsSave?.message
        //             ? pickupDetailsSave?.message
        //             : 
        //           "Error"
        //         } hideLink={true}
        //       />
        //     );
        //   },
        // });
        handleLogModalOpen();
      }
    }
  }, [starttrip]);

  //   useEffect(() => {
  //    if (saveConsignmentResponse) {
  //      confirmAlert({
  //        customUI: ({ onClose }) => {
  //          return (
  //           saveConsignmentResponse?.isSuccess === "true" ? <ConfirmPopover onClose={onClose} title={saveConsignmentResponse?.message} /> : <ErrorPopover onClose={onClose} title={saveConsignmentResponse?.description} />
  //          );
  //        }
  //      });
  //    }
  //  }, [saveConsignmentResponse]);

  const getConsignmentDetails = () => {

    if(consignmentNoDetails.consignmentNo!=""){
    loaderService.showLoader()
    apiClient
      .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER,
        {
          "consignmentNumber": consignmentNoDetails.consignmentNo,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        console.log(response.data);
        setConsignmentdetails(response.data);
        setConsignmentNoDetails({
          ...consignmentNoDetails,
          // "odometerStart":response.data.odometerReading,
          "odometerStart": response.data.consignmentMilestones?.[0]?.odometerReading,
          // "vehicleBarcode":response.data.consignmentBarCode,
          "vehicleBarcode": null,
          "comments": response.data.comments,
        })
        setConsignmentsource(response.data.consignmentSourceDetails);
        let Validstatus = ["CapturedPickUpLotDetails", "InvoiceSent", "LoadingCompleted"];
        response.data.consignmentSourceDetails.forEach(source => {
          if (!Validstatus.includes(source.consignmentStatus)) {
            setShowStarttrip(false);
          }
        })
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
        toast.error(error.message);
      });
    }
  }

  const onStart = (e) => {
    e.preventDefault();
    if (consignmentNoDetails.odometerStart) {
      startTripToDestination();
    }
    else {


      // if(!consignmentNoDetails.vehicleBarcode)
      // {
      //   setErrorMessage({ ...errorMessage, vehicleBarcodeError: "Please enter Vehicle Barcode" })    
      // }
      if (!consignmentNoDetails.odometerStart) {
        setErrorMessage({ ...errorMessage, odometerStartError: "Please enter Odometer Start Reading" })
      }
      if (!consignmentNoDetails.consignmentNo) {
        setErrorMessage({ ...errorMessage, consignmentNoError: "Please enter Consignment No" })
      }
    }
  }

  const onSave = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      consignmentSave();
    }
  }

  const consignmentSave = (e) => {

    loaderService.showLoader();
    apiClient
      .post(CONSIGNMENT_SAVE,
        {
          "consignmentNo": consignmentNoDetails.consignmentNo,
          //  "consignmentBarCode": consignmentNoDetails.vehicleBarcode,
          "consignmentBarCode": null,
          "odometerReading": consignmentNoDetails.odometerStart,
          "comments": consignmentNoDetails.comments,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSaveConsignmentResponse(response.data);
        getConsignmentDetails();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        setSaveConsignmentResponse(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onSaveLot = ()=>{
    let consignmentDetailsRequest = {...consignmentdetails}
    let sourceDetails = consignmentDetailsRequest?.consignmentSourceDetails;
    sourceDetails.forEach(grower=>{
        if(grower.id === state?.growerItem.id){
            grower = state?.growerItem;
        }
    })

    loaderService.showLoader()
    apiClient
      .post(UPDATE_CONSIGNMENT_LOT_DETAILS,
        consignmentDetailsRequest,
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        console.log(response);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });

    

  }

  const startTripToDestination = (e) => {
    loaderService.showLoader()
    apiClient
      .post(TRIP_START,
        {
          "consignmentNo": consignmentNoDetails.consignmentNo,
          "aggregatedLeftoverQuantity": consignmentNoDetails.aggregatedLeftoverQuantity,
          "totalWeight": consignmentNoDetails.totalWeight,
          "totalMoisture": consignmentNoDetails.totalMoisture,
          "consignmentSaveDetails":
          {
            "consignmentNo": consignmentNoDetails.consignmentNo,
            "odometerReading": consignmentNoDetails.odometerStart,
            "comments": consignmentNoDetails.comments
            ,
          }
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStarttrip(response.data);
        setShowStarttrip(false);
        getConsignmentDetails();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onDeliveryChallan = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      toCreateDeliveryChallan();
    }
  }

  const toCreateDeliveryChallan = (e) => {
    loaderService.showLoader();
    apiClient
      .post(CREATE_DELIVERY_CHALLAN,
        {
          "consignmentNo": consignmentNoDetails?.consignmentNo,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setCreateDeliveryChallan(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (createDeliveryChallan) {
      if (createDeliveryChallan.isSuccess === true) {
        // confirmAlert({
        //   customUI: ({ onClose }) => {
        //     return (
        //       <ErrorPopover
        //         title={pickupDetailsSave.message}
        //         onClose={onClose} hideLink={true}
        //       ></ErrorPopover> 
        //     );
        //   },
        // });
        handleLogModalOpen3();
      }
      else {
        // confirmAlert({
        //   customUI: ({ onClose }) => {
        //     return (
        //       <ConfirmPopover
        //         onClose={onClose}
        //         title={
        //           pickupDetailsSave?.message
        //             ? pickupDetailsSave?.message
        //             : 
        //           "Error"
        //         } hideLink={true}
        //       />
        //     );
        //   },
        // });
        handleLogModalOpen();
      }
    }
  }, [createDeliveryChallan]);

  const getDownloadChallan = (action) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber" : consignmentdetails?.delieryChallanNumber,
          "printDetailsType": "delivery_challan",
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadDeliveryChallan(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Output.pdf`
          );
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  return (
    <div>
      <Container fluid>
        <Row>
          {/* <Col xs={12} md={3} className='common-internal-sidebar-col'>
                <div className="common-internal-sidebar-container-vinu">
                  <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate('/dashboardStakeHolder'))} />
                </div>
              </Col> */}
          <Col xs={12} md={12}>
            {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT04</p>}
            <p className="headingStylePIT" style={{ marginLeft: "1vw" }}>Consignment Pick Up/Tracker</p>
            <div>
              <form>
                <Container fluid>
                  <Row>
                    <Col xs={12} md={4}>
                    
                      <div className="consignment-pick-up-consignment-label" >Consignment No</div>
                      <input className='consignment-pick-up-consignment-textfields' type="text" value={consignmentNoDetails?.consignmentNo} name="consignmentNo" onChange={(e) => handleChange(e)} />
                      <div className="error-msg">
                        {errorMessage.consignmentNoError}
                      </div>
                      <button className="consignment-getDetails" onClick={(e) => getDetails(e)} >Get Details.</button>
                    
                    </Col>
                    <Col xs={12} md={4}>
                    <div><label className="consignment-pick-up-consignment-label">Consignment Status : </label>{consignmentdetails?.consignmentStatus}</div>
                      {/* <div className="consignment-pick-up-consignment-label">Consignment Status</div>
                      <input className='consignment-pick-up-textfields-disabled' type="text" value={consignmentdetails?.consignmentStatus} disabled={true} /><br /> */}
                    </Col>
                  </Row>
                </Container>
                <Container fluid>
                  <Row>
                    <Col xs={12} md={4}>
                    <div><label className="consignment-pick-up-label">Consignment Owner URN : </label>{consignmentdetails?.consignmentSourceUrn}</div>
                     
                      <div><label className="consignment-pick-up-label">Consignment Owner Name : </label>{consignmentdetails?.consignmentOwnerName}</div>

                      <div><label className="consignment-pick-up-label">Consignment Owner Contact :  </label>{consignmentdetails?.consignmentOwnerContactNo}</div>

                      <div><label className="consignment-pick-up-label">Schedule Pick-Up Date : </label>{consignmentdetails?.consignmentScheduleDate && Moment(consignmentdetails?.consignmentScheduleDate).format('DD/MM/YYYY')}</div>

                      <div><label className="consignment-pick-up-label">Schedule Delivery Date : </label>{consignmentdetails?.scheduleDeliveryTimestamp && Moment(consignmentdetails?.scheduleDeliveryTimestamp).format('DD/MM/YYYY')}</div>

                      <div><label className="consignment-pick-up-label">Enter Odometer Start Reading : </label>{consignmentNoDetails.odometerStart}</div>

                      {/* <div className="error-msg">
                        {errorMessage.odometerStartError}
                      </div> */}
                    </Col>
                    <Col xs={12} md={4}>
                      <div><label className="consignment-pick-up-label">Schedule consignment Weight (MT): </label>{consignmentdetails?.scheduledWeight}</div>
                     
                      <div><label className="consignment-pick-up-label">Delivery Location Name : </label>{consignmentdetails?.consignmentDestinationLocationName}</div>

                      <div><label className="consignment-pick-up-label">Delivery Location Address : </label>{consignmentdetails?.consignmentDestinationLocationAddress}</div>

                      <div><label className="consignment-pick-up-label">Type of Inventory : </label>{consignmentdetails?.materialType}</div>
    
                      <div><label className="consignment-pick-up-label">Type Of Loading(FTL/LTL) : </label>{consignmentdetails?.typeOfLoading}</div>

                      {/* <div className="consignment-pick-up-label">Vehicle Barcode</div>
                                       <input className='consignment-pick-up-consignment-textfields' type="text" name="vehicleBarcode" value={consignmentNoDetails.vehicleBarcode} onChange={(e)=> handleChange(e)} />
                                       <div className="error-msg">
                                           {errorMessage.vehicleBarcodeError}
                                       </div> */}
                    </Col>
                    <Col xs={12} md={4}>
                      <div><label className="consignment-pick-up-label">Driver Name : </label>{consignmentdetails?.driverName}</div>

                      <div><label className="consignment-pick-up-label">Driver License No : </label>{consignmentdetails?.driverLicenseNo} </div>

                      <div><label className="consignment-pick-up-label">Driver Contact : </label>{consignmentdetails?.driverContact} </div>

                      <div><label className="consignment-pick-up-label">Vehicle Registration : </label>{consignmentdetails?.vehicleRegNo}</div>
                      
                      <div><label className="consignment-pick-up-label">Delivery Location URN : </label>{consignmentdetails?.consignmentDestinationStakeholderUrn} </div>

                    </Col>
                  </Row>
                </Container>
                <Container fluid>
                  <Row>
                    <p className='pickupdeatils-heading'>Grower Details</p>
                    <Col xs={12} md={9}>
                      <div className='common-table-div'>
                        <Table responsive className="common-table" striped>
                          <thead>
                            <tr>
                              <th className='common-table-heading-text'>Schedule Line</th>
                              <th className='common-table-heading-text'>Grower PO</th>
                              <th className='common-table-heading-text'>Pick-Up Location URN</th>
                              <th className='common-table-heading-text'>Pick-Up Location Name</th>
                              <th className='common-table-heading-text'>Pick-Up Location Address</th>
                              <th className='common-table-heading-text'>Status</th>
                              <th className='common-table-heading-text'>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {consignmentsource?.map((item, index) => (
                              <tr>
                                <td className='common-table-text'>{item.scheduleLineNumber}</td>
                                <td className='common-table-text'>{item.sourceStakeholderPo}</td>
                                <td className='common-table-text'>{item.sourceStakeholderUrn}</td>
                                <td className='common-table-text'>{item.sourceLocationName}</td>
                                <td className='common-table-text'>{item.sourceLocationAddress}</td>
                                <td className='common-table-text'>{item.consignmentStatus}</td>
                                <td>
                                  <input type="button" className="verify-btn-pickup-details" value="Lot Details" onClick={(e) => viewUpdatePickup(e, item)} />
                                </td>
                              </tr>

                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                    
                  </Row>
                </Container>

                {/* <Row>
                                <Col xs={12} md={2} col={12}>    
                                    <button className='submit-btn-RB' type='submit' onClick={(e)=>consignmentSave(e)}>Save</button>
                                </Col>
                                <Col xs={12} md={2} col={12}>    
                                    <button className='submit-btn-RB-1' type='submit' onClick={(e)=>startTripToDestination(e)}>Start Trip</button>
                                </Col>
                              </Row> */}
                <Row>
                              
                              <Col xs={12} md={12}>
                                <button className="nextBtn_consignment_complete"  onClick={(e)=>onSaveLot(e)}>Save</button>
                               
                              </Col>
                         
                           </Row>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ConfirmPopover title={starttrip?.message} navigate={navigate} goToStakeHolderDashboard="goToStakeHolderDashboard" />
        </DialogContent>
      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
        <DialogContent>
          <ConfirmPopover hideLink={true} title={starttrip?.message ? starttrip?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose1}>OK</Button>
        </DialogActions>
      </Dialog>


      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ErrorPopover title={"ERROR"} navigate={navigate} goToStakeHolderDashboard="goToStakeHolderDashboard" />
        </DialogContent>
      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover hideLink={true} title={saveConsignmentResponse?.message ? saveConsignmentResponse?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                <ConfirmPopover title={createDeliveryChallan?.message} navigate={navigate} goToStakeHolderDashboard="goToStakeHolderDashboard"/>
                </DialogContent>
            </Dialog> */}
      <Dialog maxWidth='xs' fullWidth open={logModalOpen3}>
        <DialogContent>
          <ConfirmPopover hideLink={true} title={createDeliveryChallan?.message ? createDeliveryChallan?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose3}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
export default ConsignmentLotDetails;